import _Result from './Result';
import './style/index.js';

export type { ResultProps } from './Result';
export * from './type';

export const Result = _Result;
export default Result;
